// extracted by mini-css-extract-plugin
export var clickableWrapper = "_2h-2";
export var placeholderIcon = "_2h-3";
export var thumbnailCanvas = "_2h-1";
export var thumbnailWrapper = "_2h-0";